export default __webpack_public_path__ + "static/media/up-green.2035aad9.svg";